let config = {}

if (window.userInfoConfig) {
  config = window.userInfoConfig
}

export const UserInfoConfig = config



// WEBPACK FOOTER //
// ./src/config/userInfoConfig.js